// SPDX-License-Identifier: AGPL-3.0-or-later

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file konvo/read_state/v1/read_state.proto (package konvo.read_state.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file konvo/read_state/v1/read_state.proto.
 */
export const file_konvo_read_state_v1_read_state: GenFile = /*@__PURE__*/
  fileDesc("CiRrb252by9yZWFkX3N0YXRlL3YxL3JlYWRfc3RhdGUucHJvdG8SE2tvbnZvLnJlYWRfc3RhdGUudjEixwEKDlJlYWRTdGF0ZUVudHJ5EhIKCmNoYW5uZWxfaWQYASABKAQSHAoPbGFzdF9tZXNzYWdlX2lkGAIgASgESACIAQESFQoNbWVudGlvbl9jb3VudBgDIAEoDRI2ChJsYXN0X3Bpbl90aW1lc3RhbXAYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhQKB3ZlcnNpb24YBSABKARIAYgBAUISChBfbGFzdF9tZXNzYWdlX2lkQgoKCF92ZXJzaW9uIksKD1JlYWRTdGF0ZUJ1bmRsZRI4CgtyZWFkX3N0YXRlcxgBIAMoCzIjLmtvbnZvLnJlYWRfc3RhdGUudjEuUmVhZFN0YXRlRW50cnliBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message konvo.read_state.v1.ReadStateEntry
 */
export type ReadStateEntry = Message<"konvo.read_state.v1.ReadStateEntry"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: optional uint64 last_message_id = 2;
   */
  lastMessageId?: bigint | undefined;

  /**
   * @generated from field: uint32 mention_count = 3;
   */
  mentionCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_pin_timestamp = 4;
   */
  lastPinTimestamp?: Timestamp | undefined;

  /**
   * @generated from field: optional uint64 version = 5;
   */
  version?: bigint | undefined;
};

/**
 * Describes the message konvo.read_state.v1.ReadStateEntry.
 * Use `create(ReadStateEntrySchema)` to create a new message.
 */
export const ReadStateEntrySchema: GenMessage<ReadStateEntry> = /*@__PURE__*/
  messageDesc(file_konvo_read_state_v1_read_state, 0);

/**
 * @generated from message konvo.read_state.v1.ReadStateBundle
 */
export type ReadStateBundle = Message<"konvo.read_state.v1.ReadStateBundle"> & {
  /**
   * @generated from field: repeated konvo.read_state.v1.ReadStateEntry read_states = 1;
   */
  readStates: ReadStateEntry[];
};

/**
 * Describes the message konvo.read_state.v1.ReadStateBundle.
 * Use `create(ReadStateBundleSchema)` to create a new message.
 */
export const ReadStateBundleSchema: GenMessage<ReadStateBundle> = /*@__PURE__*/
  messageDesc(file_konvo_read_state_v1_read_state, 1);

